import { Table, Tag } from "antd";
import { TFunction, useTranslation } from "react-i18next";
import { UpdateEvent } from "../../../api/models";
import { PagedApiState } from "../../../api/useApiState";
import { toAntdPagination } from "../../../util";
import { formatLocalizedDateTime } from "../../../util/formatting";

interface BeaconEventTableProps {
  eventHistory: PagedApiState<UpdateEvent>;
}

export function BeaconEventTable({ eventHistory }: BeaconEventTableProps) {
  const { t } = useTranslation();

  return (
    <Table
      sticky
      dataSource={eventHistory.value?.items || []}
      rowKey={(record) => `${record.event}-${record.ts}-${Math.random()}`}
      size="middle"
      loading={eventHistory.loading}
      columns={[
        {
          title: t("timestamp"),
          dataIndex: "ts",
          sorter: (a, b) =>
            (new Date(a.ts)?.getTime() || 0) - (new Date(b.ts)?.getTime() || 0),
          render: (ts) =>
            ts ? formatLocalizedDateTime(ts) : t("beacon:is-on-off-unknown"),
        },
        {
          title: t("lifecycle:status"),
          render: (e: UpdateEvent) => eventStatus(e.event, t),
        },
      ]}
      pagination={toAntdPagination(eventHistory, false)}
    ></Table>
  );
}

const eventStatus = (eventName: string, t: TFunction<"translation">) => {
  switch (eventName) {
    case "power on":
      return <Tag color="green">{t("beacon:is-on-off-on")}</Tag>;
    case "power off":
      return <Tag color="black">{t("beacon:is-on-off-off")}</Tag>;

    case "motion detected":
      return <Tag color="violet">{t("beacon:is-on-off-movement")}</Tag>;
    case "heartbeat":
      return <Tag color="orange">{t("beacon:is-on-off-heartbeat")}</Tag>;
    default:
      return <Tag color="gray">{t("beacon:is-on-off-unknown")}</Tag>;
  }
};
